import Notifications from 'vue-notification';
import CKEditor from '@ckeditor/ckeditor5-vue';
import '@ckeditor/ckeditor5-build-inline/build/translations/ru';

Vue.use(Notifications);
Vue.use(CKEditor);
Vue.component('vue-cropper', require('vue-cropperjs').default);